const WORDS_PER_MINUTE = 200;

function countWords(text) {
  if (!text || typeof text !== "string") return 0;
  return text
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
}

/**
 * @param {{ descricao?: string, resumo?: string, conteudo?: string }} fields
 * @returns {number}
 */
export function estimateReadingMinutes(fields) {
  const total =
    countWords(fields.descricao) +
    countWords(fields.resumo) +
    countWords(fields.conteudo);
  return Math.max(1, Math.ceil(total / WORDS_PER_MINUTE));
}

export { WORDS_PER_MINUTE };
